import $ from 'jquery';
import 'slick-carousel';
import Parallax from './Parallax';
import PlayPauseControls from './PlayPauseControls';

const defaults = {
  fade: true,
  dots: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 4000,
  appendArrows: '.slick-arrows',
};

export default class Hero {
  constructor(element, options) {
    this.$element = $(element);
    this.settings = Object.assign({}, defaults, options);
    this.$element.find('.view').append('<div class="slick-arrows"></div>');
    this.carousel = this.buildCarousel();
    this.controls = this.addControls();
    this.addParallax();
    this.ready();
  }

  buildCarousel() {
    return this.$element.find('.view-content').slick(this.settings);
  }

  addControls() {
    return new PlayPauseControls(this.carousel, {
      attachTo: this.$element.find('.slick-arrows'),
    });
  }

  addParallax() {
    return this.$element.find('.field-image.c1').each((i, element) => {
      if (!element.Parallax) {
        element.Parallax = new Parallax(element);
      }
    });
  }

  ready() {
    return this.$element.addClass('ready');
  }
}
